import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List, Map, fromJS } from 'immutable';
import classNames from 'classnames';

import ActiveRouterLink from '../ActiveRouterLink';

import style from './style.module.css';

const defaultActive = fromJS({});

/**
 * Tab component. Uses `<li><a href={to}>{children content}</a></li>`.
 * Also `<li>` has .active class if it is the current route.
 *
 * @param props {Object}.
 * @param props.to {String} Url to change window.location on click.
 */
const Tab = props => {
  const { children, to, name, available = false, onClick } = props;
  let { className } = props;

  if (available) className += ' available-tab';

  const handleClick = event => {
    if (onClick) {
      event.preventDefault();
      event.stopPropagation();
      onClick({ name, to });
    }
  };

  return (
    <ActiveRouterLink classes={className} name={name} onClickCapture={handleClick} to={to} wrapper="li">
      {children}
    </ActiveRouterLink>
  );
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
};

/**
 * Tabs row component.
 *
 * @param props {Object}.
 * @param props.tabs {Immutable.List} List of Immutable.Maps. Every map is a tab with #name and #to keys.
 *     Tabs are react-router links.
 */
const Tabs = props => {
  const { tabs, tabClass, className, availableTabs = defaultActive, onClick } = props;
  const tabClassContent = tabClass || classNames(style.host, 'nav', className);

  const content = tabs.map((tab, i) => (
    <Tab
      key={i}
      available={availableTabs.get(tab.get('key'))}
      className={tab.get('className')}
      name={tab.get('name')}
      onClick={onClick}
      to={tab.get('to')}
    >
      {tab.get('name')}
    </Tab>
  ));

  return <ul className={tabClassContent}>{content}</ul>;
};

Tabs.propTypes = {
  availableTabs: PropTypes.instanceOf(Map),
  className: PropTypes.string,
  tabs: PropTypes.instanceOf(List).isRequired,
};

export default memo(Tabs);
